module.exports = __webpack_public_path__ + "img/firstview-online-b62ae8ec49568f5330aedc96de02c3c0.96f115e0.jpg";